module.exports = __webpack_public_path__ + "img/cri.b69c7f6a.svg";